import { store } from "@src/index";

import {
    leagueManagementActions,
    selectSelectedLeague,
} from "@features/leaguemgmt/leagueManagementSlice";

import { getLeagueSchedule } from "@lib/api";

const loader = async ({ params }: any) => {
    let { leagueId } = params;
    leagueId = parseInt(leagueId);

    let leagues = store.getState().leaguemanagement.leagues;
    const leaguesPromise = leagues.length
        ? Promise.resolve()
        : store.dispatch(leagueManagementActions.getLeagues());

    const [{ schedule }] = await Promise.all([
        getLeagueSchedule(leagueId),
        leaguesPromise,
    ]);

    store.dispatch(leagueManagementActions.setSelectedLeague(leagueId));
    const league = selectSelectedLeague(store.getState());

    const header = league
        ? `${league.ageLevel}${
              league.designation ? ` ${league.designation}` : ""
          }${league.direction ? ` ${league.direction}` : ""} Schedule`
        : "League Schedule";

    return {
        schedule,
        header,
    };
};

export default loader;
